import React, { useEffect } from 'react';
import { Button, Font, Heading3, Modal } from 'is24-corecss';

import { performLifecycleTransition } from '../../../../api/TeamMemberApi';
import { TeamMember } from '../../../../models/TeamMember';
import { getErrorMessage } from '../../../../common/statusMesssages';
import { StatusMessageType } from '../../types/StatusMessageType';

import styles from './styles.module.css';
import { reportActionEvent, reportViewEvent } from '../../../../tracking/tracking';

type InviteTeamMemberModalProps = {
  visible: boolean;
  onClose: () => void;
  onInvite: (status?: StatusMessageType) => void;
  selectedTeamMember: TeamMember | null;
};

const InviteTeamMemberModal: React.FC<InviteTeamMemberModalProps> = ({
  visible,
  onClose,
  onInvite,
  selectedTeamMember,
}: InviteTeamMemberModalProps) => {
  const PAGE_VIEW_TITLE = 'send_invitation';

  useEffect(() => {
    visible && reportViewEvent({ pageTitle: PAGE_VIEW_TITLE });
  }, [visible]);

  const handleInviteTeamMember = async () => {
    try {
      if (selectedTeamMember && selectedTeamMember.id) {
        await performLifecycleTransition(selectedTeamMember.id, { command: 'invite' });
        onInvite();
        reportActionEvent({ pageTitle: PAGE_VIEW_TITLE, label: 'invitation_sent', event_name: 'teammanagement_invitation_sent' });
      }
    } catch (e) {
      onInvite(getErrorMessage(e));
    }
  };

  return (
    <Modal visible={visible} onClose={onClose} title='Einladung erneut senden' width={864}>
      <div data-testid='invite-team-member-modal' className='grid-item one-whole padding-bottom-l align-center grid-align-center'>
        <span className={styles.centeredTextBlock}>
          <span className={`is24-icon-profile ${styles.largeIcon}`}></span>
          <Heading3>
            <span data-testid='team-member-email' className='padding-bottom-m'>
              {selectedTeamMember && selectedTeamMember.email}
            </span>
          </Heading3>
        </span>
      </div>
      <div data-testid='invite-confirmation-text' className='grid-item one-whole padding-bottom-l align-center grid-align-center'>
        <Font className='padding-bottom-m' weight='bold'>
          Soll die Einladung erneut gesendet werden?
        </Font>
      </div>
      <div className='padding-left-m align-center'>
        <Button data-testid='perform-team-member-invitation-button' appearance='primary' className='one-half' onClick={handleInviteTeamMember}>
          Einladung erneut senden
        </Button>
      </div>
      <div className='padding-right-m padding-top-m align-center'>
        <button className='link-text' onClick={onClose}>
          Abbrechen
        </button>
      </div>
    </Modal>
  );
};

export default InviteTeamMemberModal;
